import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Tabs from '../tabs/Tabs';
import ExamSignInForm from '../forms/ExamSignInForm';
import ExamRegForm from '../forms/ExamRegForm';

const TABS_DATA = [
  {
    id: 10,
    name: 'J’ai déjà un compte',
  },
  {
    id: 20,
    name: 'Inscription',
  },
];

const RegistrationTabs = ({
  examCenter, onExamSigninFormSubmitHandler, onExamRegFormSubmitHandler, formForRecoveryPoints,
}) => {
  const [activeTab, setActiveTab] = useState(TABS_DATA[0]);

  const tabChangeHandler = (chosedTab) => {
    setActiveTab(chosedTab);
  };

  return (
    <>
      <Tabs
        tabs={TABS_DATA}
        activeTab={activeTab}
        onTabChange={tabChangeHandler}
      />
      {activeTab.id === TABS_DATA[0].id ? (
        <ExamSignInForm
          examCenterType={examCenter}
          onFormSubmit={onExamSigninFormSubmitHandler}
          onClickGoToRegForm={() => setActiveTab(TABS_DATA[1])}
          formForRecoveryPoints={formForRecoveryPoints}
        />
      ) : (
        <ExamRegForm
          examCenterType={examCenter}
          onFormSubmit={onExamRegFormSubmitHandler}
          onClickGoToSignInForm={() => {
            setActiveTab(TABS_DATA[0]);
            window.scrollTo(0, 0);
          }}
          formForRecoveryPoints={formForRecoveryPoints}
        />
      )}
    </>
  );
};

RegistrationTabs.propTypes = {
  examCenter: PropTypes.string.isRequired,
  onExamSigninFormSubmitHandler: PropTypes.func.isRequired,
  onExamRegFormSubmitHandler: PropTypes.func.isRequired,
  formForRecoveryPoints: PropTypes.bool,
};

export { RegistrationTabs };
